<template>
  <div class="c-table">
    <el-form @submit.prevent.native v-if="fields.length > 0 || $slots.operate" inline>
      <slot name="content"></slot>
      <template v-for="(field, index) in fields">
        <el-form-item
          :key="index"
          :label="field.label"
          :prop="field.prop"
          v-show="field.component !== 'hidden'"
          v-if="field.visible !== false"
        >
          <el-select v-if="field.component === 'select'" v-bind="field" v-model="form[field.prop]">
            <el-option v-for="option in field.options" :key="option.value" v-bind="option"></el-option>
          </el-select>
          <el-radio-group
            v-else-if="field.component === 'radio'"
            v-model="form[field.prop]"
          >
            <el-radio-button
              v-for="option in field.options"
              :key="option.value"
              :label="option.value"
            >{{option.label}}</el-radio-button>
          </el-radio-group>
          <component
            v-else-if="field.component !== undefined"
            :is="typeof field.component === 'string' ? `el-${field.component}` : field.component"
            v-bind="field"
            v-model="form[field.prop]"
          ></component>
          <el-input v-else v-bind="field" v-model="form[field.prop]" @keyup.13.native="onSearch"></el-input>
        </el-form-item>
      </template>
      <el-form-item v-if="fields.length > 0 ">
        <el-button icon="el-icon-search" @click="onSearch"></el-button>
      </el-form-item>
      <el-form-item class="operate">
        <slot name="operate"></slot>
      </el-form-item>
    </el-form>
    <template v-if="(currentColumns.length > 0 || !$scopedSlots.default)&&currentData">
      <el-table v-loading="loading" v-bind="$attrs" v-on="$listeners" :data="currentData">
        <template v-for="(column, index) in currentColumns">
          <el-table-column
            v-if="column.slot === 'selection'"
            type="selection"
            width="55"
            :key="index"
          ></el-table-column>
          <slot v-else-if="column.slot" :name="column.slot"></slot>
          <component
            v-else-if="column.component"
            :is="column.component"
            :column="column"
            :key="index"
          ></component>
          <el-table-column v-else v-bind="column" :key="index">
            <template slot-scope="scope">
              <span v-html="column.filter ? column.filter(scope.row[column.prop],scope.row) : scope.row[column.prop]"></span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </template>
    <div class="c-table__masonry" v-else v-loading="loading">
      <el-row :gutter="16">
        <el-col v-for="(item, index) in data" :key="item.prodId" :xs="12" :sm="12" :md="6" :xl="4">
          <el-card shadow="hover" :key="index">
            <slot :item="item"></slot>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="c-table__pagination" v-if="paging">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 15, 30]"
        :page-size="pagination.num"
        :current-page.sync="pagination.page"
        :total="pagination.total"
        @size-change="onSizeChange"
        @current-change="onCurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: 'c-table',
  props: {
    url: {
      type: String,
      required: true
    },
    defaultParam: {
      type: Object,
      default () {
        return {}
      }
    },
    fetchPage: {
      type: [Boolean, Object],
      default () {
        return false
      }
    },
    fields: {
      type: Array,
      default () {
        return []
      }
    },
    columns: {
      default () {
        return []
      }
    },
    paging: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      maxHeight: 500,
      form: {},
      loading: false,
      data: [],
      pagination: {
        total: 0,
        page: 1,
        num: 10
      },
      dParam: this.defaultParam
    }
  },
  computed: {
    currentData() {
      const { page, num } = this.pagination
      return this.fetchPage ? this.data : this.data.slice((page - 1) * num, page * num)
    },
    currentColumns() {
      return this.columns.filter(x => !x.disable)
    }
  },
  created () {
    this.fields.filter(x => x.prop).forEach(x => {
      this.$set(this.form, x.prop, x.value)
    })
    // 请求每页多少条，不是一次请求，然后分次翻页
    if (this.fetchPage && this.fetchPage.num) {
      this.pagination.num = this.fetchPage.num
    }
    this.fetch()
  },
  mounted () {
    // this.fields.filter(x => x.prop).forEach(x => {
    //   this.$set(this.form, x.prop, x.value)
    // })
    // // 请求每页多少条，不是一次请求，然后分次翻页
    // if (this.fetchPage && this.fetchPage.num) {
    //   this.pagination.num = this.fetchPage.num
    // }
    // this.fetch()
    this.$nextTick(() => {
      this.maxHeight = document.querySelector('main').clientHeight - this.$el.querySelector('.el-table').getBoundingClientRect().top - 60
    })
  },
  methods: {
    onSearch () {
      this.pagination.page = 1
      this.fetch()
    },
    onSizeChange (num) {
      this.pagination.num = num
      this.pagination.page = 1
      if (this.fetchPage) {
        this.fetch()
      }
    },
    onCurrentChange (page) {
      this.pagination.page = page
      if (this.fetchPage) {
        this.fetch()
      }
    },
    fetch () {
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.form))
      if (this.dParam) {
        params = {
          ...this.dParam,
          ...params
        }
      }
      if (this.fetchPage) {
        params.page = this.pagination.page
        params.num = this.pagination.num
      }
      this.$emit('before-fetch', params)
      this.$http
        .post(this.url, {
          ...params
        })
        .then(res => {
          if (!res.data || res.data.code === 402) {
            this.$message.error('对不起,你无权访问,如有需要请联系相关技术人员')
            this.loading = false
            return
          }
          if (!res.data.data) {
            res.data.data = res.data ? Object.values(res.data).find(val => val instanceof Array) : []
          }

          this.$emit('after-fetch', res)

          // this.data = res.data.data

          let result = this.$utils.cloneDeep(res.data.data)
          Array.isArray(res.data.data) && result.forEach(item => {
            if (item['property'] && Array.isArray(item['property'])) {
              item['property'].forEach(i => {
                if (item[i['propertyname']] == undefined) {
                  // item[i['propertyname']] = i['propertyvalue']
                  item[i['propertyname']] = { id: i['propertyid'], value: i['propertyvalue'] }
                } else {
                  item[i['propertyname']] = [item[i['propertyname']]]
                  // item[i['propertyname']].push(i['propertyvalue'])
                  item[i['propertyname']].push({ id: i['propertyid'], value: i['propertyvalue'] })
                }
              })
              delete item['property']
            }
          })
          this.data = result
          this.pagination.total = res.data.number || res.data.total
          this.loading = false
        })
    },
    reload () {
      this.pagination.page = 1
      this.fetch()
    }
  }
}
</script>

<style lang="scss">
@include b(c-table) {
  background: #fff;
  padding: 24px 20px;
  > .el-form {
    &::after {
      content: ' ';
      display: block;
      clear: both;
    }
    .operate {
      float: right;
      margin-right: 0;
    }
    .el-input,
    .el-select {
      width: 200px;
    }
  }
  .el-table {
    border: 1px solid #e3e6e9;
    border-radius: 2px;
    font-size: 14px;
    th,
    thead.is-group th {
      background: #f4f4f4;
      color: #333;
    }
    tr {
      background: #fff;
    }
    &__body tr:last-of-type td {
      border: none;
    }
    &::before,
    &__fixed::before,
    &__fixed-right::before {
      height: 0;
    }
    .cell {
      padding: 0 15px;
    }
    .el-link{
      font-size:12px;
      display: inline-block;
    }
    .el-link+.el-button,
    .el-button+.el-link,
    .el-link+.el-link{
      margin-left:10px;
    }
  }
  @include e(pagination) {
    text-align: right;
    .el-pagination {
      padding: 20px 0 0;
      .el-select .el-input .el-input__inner {
        border-radius: 4px;
      }
      &.is-background .btn-next,
      .btn-prev,
      .el-pager li {
        background: #fff;
        border: 1px solid $color-border;
        border-radius: 4px;
      }
      &.is-background .el-pager li:not(.disabled).active {
        border: 1px solid $color-theme;
      }
    }
  }
}
</style>
